import { combineReducers } from "redux";
import { createResponsiveStateReducer } from "redux-responsive";
import { routerReducer } from "react-router-redux";
import localeReducer from "./LocaleReducer";
import sessionReducer from "./SessionReducer";
import dashboardReducer from "./DashboardReducer";
import ordersReducer from "./OrdersReducer";
import productsReducer from "./ProductsReducer";
import statementsReducer from "./StatementsReducer";
import transferReducer from "./TransferReducer";
import reportsReducer from "./ReportsReducer";
import inventoryReducer from "./InventoryReducer";
import importReducer from "./ImportReducer";
import stockRequestReducer from "./StockRequestReducer";
import disputesReducer from "./DisputesReducer";

const bp = {
  smallMobile: 339,
  mobile: 549,
  phablet: 767,
  tablet: 991,
  desktop: 1199,
  largeDesktop: 1689
};
export default combineReducers({
  locale: localeReducer,
  session: sessionReducer,
  dashboard: dashboardReducer,
  inventory: inventoryReducer,
  orders: ordersReducer,
  transfer: transferReducer,
  products: productsReducer,
  statements: statementsReducer,
  reports: reportsReducer,
  routing: routerReducer,
  import: importReducer,
  stockRequest: stockRequestReducer,
  disputes: disputesReducer,
  browser: createResponsiveStateReducer(bp)
});



// WEBPACK FOOTER //
// ./src/reducers/index.js